import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { RequestInstrumentationService } from '../services/request-instrumentation.service';

export const requestInstrumentationInterceptor: HttpInterceptorFn = (req, next) => {
  const instrumentation = inject(RequestInstrumentationService);
  return instrumentation.instrument(
    req.method,
    req.url,
    next(req),
    event => event instanceof HttpResponse
  );
};
